// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZaiChatMobilePageView {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.ZaiChatMobilePageView .ZaiChatMobilePageView-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px;
}
.ZaiChatMobilePageView .ZaiChatMobilePageView-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--color_neutral_800);
}
.ZaiChatMobilePageView .ZaiChatMobilePageView-body {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  flex: 1 1;
}
.ZaiChatMobilePageView .ZaiChatMobilePageView-body > button {
  padding: 4px 8px 4px 4px;
}
.ZaiChatMobilePageView .ZaiChatMobilePageView-body > button svg {
  flex: none;
}
.ZaiChatMobilePageView .ZaiChatMobilePageView-footer {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-chat-mobile-page/zai-chat-mobile-page.styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AADJ;AAGI;EACE,wBAAA;AADN;AAGM;EACE,UAAA;AADR;AAME;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAJJ","sourcesContent":[".ZaiChatMobilePageView {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n\n  .ZaiChatMobilePageView-content {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n    padding: 16px;\n  }\n\n  .ZaiChatMobilePageView-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--color_neutral_800);\n  }\n\n  .ZaiChatMobilePageView-body {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n    flex: 1;\n\n    & > button {\n      padding: 4px 8px 4px 4px;\n\n      svg {\n        flex: none;\n      }\n    }\n  }\n\n  .ZaiChatMobilePageView-footer {\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
